import apiClient from "@/utils/api-client";
import { resolveDeviceContext } from "@/utils/device-context";

export type DeviceInitResponse = {
    deviceCode: string;
    userCode: string;
    expiresIn: number;
    verificationUri: string;
    verificationUriComplete: string;
};

export type DevicePollResponse =
    | { status: "AUTHORIZATION_PENDING"; userCode?: string }
    | { status: "AUTHORIZED"; accessToken: string; refreshToken: string; userCode?: string }
    | { status: "ISSUED"; userCode?: string }
    | { status: "EXPIRED"; userCode?: string };

class DeviceAuthService {
    approve(userCode: string): Promise<boolean> {
        return apiClient
            .post("/api/v1/auth/device/approve", { userCode })
            .then((r) => r.data === true);
    }

    init(): Promise<DeviceInitResponse> {
        return resolveDeviceContext().then((device) => {
            return apiClient
                .post("/api/v1/auth/device/init", {
                    clientId: "procricket",
                    deviceTempId: device.device_identifier,
                    deviceInfo: {
                        device_identifier: device.device_identifier,
                        device_type: device.device_type,
                        device_os: device.device_os,
                        device_name: device.device_name ?? null,
                        website: window.location.hostname,
                        user_agent: device.user_agent ?? null,
                    },
                })
                .then((r) => r.data as DeviceInitResponse);
        });
    }

    poll(deviceCode: string): Promise<DevicePollResponse> {
        return apiClient
            .get("/api/v1/auth/device/poll", { params: { device_code: deviceCode } })
            .then((r) => r.data as DevicePollResponse);
    }
}

export default new DeviceAuthService();
